var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "permissions__manager__component" },
    [
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-role",
          attrs: {
            size: "sm",
            "hide-footer": "",
            id: "editRoleModal",
            title: "Edit role title"
          }
        },
        [
          _c("EditRoleModal", {
            ref: "refEditModal",
            attrs: { roleData: _vm.role }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Delete",
            id: "confirmDeleteRole",
            "ok-title": "Yes, Remove"
          },
          on: { ok: _vm.removeRole }
        },
        [_c("p", [_vm._v("Are you sure you want to remove this role?")])]
      ),
      _vm._v(" "),
      _c("HeaderControls"),
      _vm._v(" "),
      _c("div", { staticClass: "fixed-top-bar-padding" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "role-permissions row no-gutters" }, [
            _c("div", { staticClass: "roles col-sm-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v("Roles")]),
                  _vm._v(" "),
                  _c("multiselect", {
                    ref: "role",
                    attrs: {
                      "track-by": "id",
                      label: "name",
                      "open-direction": "bottom",
                      options: _vm.allRoles,
                      "show-labels": false,
                      multiple: false,
                      allowEmpty: false,
                      taggable: true,
                      "close-on-select": true,
                      "hide-selected": false,
                      "preserve-search": true,
                      "clear-on-select": true,
                      tagPlaceholder: "Press enter to create a role"
                    },
                    on: { input: _vm.getRolePermissions, tag: _vm.createRoles },
                    model: {
                      value: _vm.role,
                      callback: function($$v) {
                        _vm.role = $$v
                      },
                      expression: "role"
                    }
                  }),
                  _vm._v(" "),
                  _vm.userAbilities.roleManager
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showRoleBtns,
                              expression: "showRoleBtns"
                            }
                          ],
                          staticClass: "role-btns text-primary"
                        },
                        [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "cursor-pointer",
                              attrs: { title: "Edit role" },
                              on: { click: _vm.showEditRoleModal }
                            },
                            [_c("i", { staticClass: "fas fa-edit" })]
                          ),
                          _vm._v(" "),
                          _vm.showDeleteRole
                            ? _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true }
                                    }
                                  ],
                                  staticClass: "cursor-pointer",
                                  attrs: { title: "Delete role" },
                                  on: {
                                    click: function($event) {
                                      return _vm.$bvModal.show(
                                        "confirmDeleteRole"
                                      )
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fas fa-trash" })]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "permissions col-sm-12 col-md-9" }, [
              _c("label", [_vm._v("Permissions")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "permission-checkbox-groups-container" },
                _vm._l(_vm.getMaxGroupNumber(), function(i) {
                  return _c(
                    "b-form-checkbox-group",
                    {
                      key: i,
                      staticClass: "permission-group",
                      attrs: {
                        id: "permission-checkbox-group-" + i,
                        name: "permission",
                        disabled: !_vm.userAbilities.roleManager
                      },
                      model: {
                        value: _vm.ability,
                        callback: function($$v) {
                          _vm.ability = $$v
                        },
                        expression: "ability"
                      }
                    },
                    _vm._l(
                      _vm.allAbilities.filter(function(x) {
                        return x.group_number == i
                      }),
                      function(j) {
                        return _c(
                          "b-form-checkbox",
                          {
                            key: j.id,
                            staticClass: "permission-entry",
                            attrs: { value: j.value }
                          },
                          [_vm._v(_vm._s(j.text))]
                        )
                      }
                    ),
                    1
                  )
                }),
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "preferences col-sm-12 col-md-3" }),
            _vm._v(" "),
            _c("div", { staticClass: "preferences col-sm-12 col-md-9" }, [
              _c("label", [_vm._v("Default Preferences")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "preferences-deliverable-type-container" },
                [
                  _c("multiselect", {
                    ref: "roleDefaultDeliverableType",
                    attrs: {
                      "show-labels": false,
                      multiple: true,
                      options: _vm.preferenceDeliverableTypes,
                      label: "name",
                      "track-by": "id"
                    },
                    model: {
                      value: _vm.preferenceData,
                      callback: function($$v) {
                        _vm.preferenceData = $$v
                      },
                      expression: "preferenceData"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.userAbilities.roleManager
              ? _c(
                  "div",
                  { staticClass: "col-12 mt-2" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "header-filter-btns",
                        attrs: { variant: "theme" },
                        on: { click: _vm.saveRolePermissions }
                      },
                      [
                        _vm._v(
                          "\n                      Save\n                      "
                        ),
                        _c("i", {
                          staticClass:
                            "fas text-primary fa-save fa-fw float-right"
                        })
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid" }, [
      _c("h2", { staticClass: "permission-title-manager" }, [
        _c("span", { staticClass: "title-icon" }, [
          _c("i", { staticClass: "fas fa-user-lock" })
        ]),
        _vm._v("\n              Permission Manager\n          ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }